import { render, staticRenderFns } from "./WorkflowDetails.vue?vue&type=template&id=dcb6ae7c&scoped=true&"
import script from "./WorkflowDetails.vue?vue&type=script&lang=ts&"
export * from "./WorkflowDetails.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowDetails.vue?vue&type=style&index=0&id=dcb6ae7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb6ae7c",
  null
  
)

export default component.exports